export class GenericField
{
    id:number;
    name:string;
    entityName:string;
    columnName:string;
    label:string;
    dataType:string;
    primary:Boolean;
    formatType:string;
    pickListId:number;
    dropdownList:any[];
}